


































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import { RouterNames } from "@/router/routernames";
import { UtilsString } from "@/utils/utils-string";
import { ssmTokenService } from "@/shared/services/token-service";
import { medicalUserService } from "@/shared/services/user-service";
import { ProcessoNums } from "../procesos/ProcessoNums";
import TiendaOnlineClientesModule from "@/store/modules/TiendaOnlineClientes-module";
import tienda_cart_module from "@/store/modules/tienda_cart_module";

@Component({
  components: {},
})
export default class productos_scroll_infinito extends Vue {
  selectedProcessoNum: number | null = 0;
  searchQueryExecute: string = "";
  tags: { id: number; text: string }[] = [
    {
      id: 100,
      text: "Todos",
    },
    {
      id: ProcessoNums.Disponible,
      text: "Disponible",
    },
    { id: ProcessoNums.Reservado, text: "Reservado" },
    { id: ProcessoNums.VendidoEfectivo, text: "Vendido" },
    { id: ProcessoNums.Devolucion, text: "Devolución" },
    { id: ProcessoNums.MermaRoto, text: "MermaRoto" },
    { id: ProcessoNums.Envio, text: "Envio" },
    { id: ProcessoNums.PendientePago, text: "PendientePago" },
    { id: ProcessoNums.Reparacion, text: "Reparacion" },
  ];
  productsPerPage = 20;
  currentPage = 1;
  created() {
    if (this.$route.query.search) {
      // Llama a la función con el valor del parámetro
      TiendaOnlineClientesModule.SetSearchQuery(
        UtilsString.ValueOf(this.$route.query.search)
      );
      // this.searchQueryExecute = UtilsString.ValueOf(this.$route.query.search);
    }

    // Restaurar el scroll si hay una posición guardada
    const savedScrollPosition = localStorage.getItem("scrollPosition");
    if (savedScrollPosition) {
      window.scrollTo(0, parseInt(savedScrollPosition)); // Restauramos el scroll
      localStorage.removeItem("scrollPosition"); // Limpiamos la posición después de usarla
    }

    this.CargaNormal();
  }

  CargaNormal() {
    if (TiendaOnlineClientesModule.TiendaOnlineClienteses.length === 0) {
      if (ssmTokenService.hasToken() && medicalUserService.hasuser()) {
        // Si hay un token y un usuario, obtenemos todos los productos con paginación
        TiendaOnlineClientesModule.getTiendaOnlineClientesesTodosPaginacion({
          skip: 0,
          take: this.productsPerPage,
          selectedProcessoNumber: this.selectedProcessoNum || 0,
          search: this.searchQuery,
        });
      } else {
        this.selectedProcessoNum = ProcessoNums.Disponible; // Asignar un valor por defecto
        // Si no hay token ni usuario, obtenemos productos limitados o sin paginación
        TiendaOnlineClientesModule.getTiendaOnlineClientesesTodosPaginacion({
          skip: 0,
          take: this.productsPerPage,
          selectedProcessoNumber: this.selectedProcessoNum,
          search: this.searchQuery,
        });
      }
    }
  }

  async loadMore() {
    const skip = this.products.length; // ya cargados
    const take = this.productsPerPage * 2; // por página
    const nuevos =
      await TiendaOnlineClientesModule.getTiendaOnlineClientesesTodosPaginacionSinAction(
        {
          skip: skip,
          take: take,
          selectedProcessoNumber: this.selectedProcessoNum || 0,
          search: this.searchQuery,
        }
      );

    TiendaOnlineClientesModule.onGetTiendaOnlineClientesesPaginacionNuevosADD(
      nuevos
    );
    // this.products.push(...nuevos.Pro);
  }

  mounted() {
    // Restauramos el estado de los productos y la página
    const savedProducts = TiendaOnlineClientesModule.TiendaProductosCahe;
    const savedPage = localStorage.getItem("currentPage");

    if (savedProducts) {
      // Si hay productos guardados, los restauramos
      if (TiendaOnlineClientesModule.TiendaProductosCahe.length) {
        TiendaOnlineClientesModule.onGetTiendaOnlineClienteses([]);
        var products = TiendaOnlineClientesModule.TiendaProductosCahe; // Restauramos los productos
        TiendaOnlineClientesModule.onGetTiendaOnlineClientesesPaginacionNuevosADD(
          { Productos: products, Total: products.length } // Restauramos los productos
        );
      }

      localStorage.removeItem("currentPage");
    }

    if (savedPage) {
      this.currentPage = parseInt(savedPage); // Restauramos la página
      localStorage.removeItem("scrollPosition");
    }

    // Restauramos el scroll
    const savedScrollPosition = localStorage.getItem("scrollPosition");
    if (savedScrollPosition) {
      window.scrollTo(0, parseInt(savedScrollPosition)); // Restauramos el scroll
      localStorage.removeItem("scrollPosition"); // Limpiamos la posición después de usarla
    }
  }

  get paginatedProducts() {
    return this.filteredProducts.slice(
      0,
      this.currentPage * this.productsPerPage
    );
  }
  get canLoadMore() {
    return this.totalProductos > this.paginatedProducts.length;
  }
  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  onIntersect(entries: any) {
    const entry = entries[0];
    if (entry.isIntersecting && this.canLoadMore) {
      this.currentPage++;
      this.loadMore();
    }
  }

  visitar_producto(Producto: ProductoAmazon) {
    // Guardamos la posición del scroll antes de navegar
    localStorage.setItem("scrollPosition", window.scrollY.toString());
    // Guardamos el estado de los productos y la página en localStorage
    TiendaOnlineClientesModule.onSetCache(this.products);
    localStorage.setItem("currentPage", JSON.stringify(this.currentPage));

    // Determinar flag mayorista desde la ruta actual
    var mayorista = false;
    if (
      this.$route &&
      this.$route.meta &&
      typeof this.$route.meta.mayorista !== "undefined"
    ) {
      mayorista = this.$route.meta.mayorista === true;
    }

    // Navegar pasando el flag por query (m=1/0)
    this.$router
      .push({
        name: RouterNames.tienda_producto,
        params: {
          id: UtilsString.ValueOf((Producto as any).id),
        },
        query: {
          m: mayorista ? "1" : "0",
        },
      })
      .catch(function () {
        /* noop */
      });
  }
  get esta_logeado() {
    return ssmTokenService.hasToken() && medicalUserService.hasuser();
  }
  get products() {
    return TiendaOnlineClientesModule.TiendaOnlineClienteses;
  }
  get searchQuery() {
    this.searchQueryExecute = TiendaOnlineClientesModule.searchQuery;
    return TiendaOnlineClientesModule.searchQuery;
  }
  get filteredProducts() {
    if (!this.searchQuery) return this.products;
    const query = this.searchQuery.toLowerCase();
    return this.products;
    return this.products.filter(
      (product) =>
        product.titulo_producto.toLowerCase().includes(query) ||
        product.asin.toLowerCase().includes(query) ||
        product.lpn.toLowerCase().includes(query) ||
        product.lpn.toLowerCase().includes(query) ||
        product.localizacion.toLowerCase().includes(query)
    );
  }
  get totalProductos() {
    return TiendaOnlineClientesModule.totalProductos; // Asegúrate de que esta propiedad esté almacenada correctamente
  }
  clearSearch() {
    TiendaOnlineClientesModule.SetSearchQuery("");
  }

  async handleProcessoNumChange() {
    await TiendaOnlineClientesModule.getTiendaOnlineClientesesTodosPaginacion({
      skip: 0,
      take: this.productsPerPage,
      selectedProcessoNumber: this.selectedProcessoNum || 0,
      search: this.searchQuery,
    });
    if (this.selectedProcessoNum !== null) {
      switch (this.selectedProcessoNum) {
        case ProcessoNums.Disponible:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) =>
              product.estado === ProcessoNums.Disponible &&
              product.vendido === false
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.Reservado:
          var lista = this.paginatedProducts.filter(
            (product) => product.estado === ProcessoNums.Reservado
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.VendidoEfectivo:
        case ProcessoNums.VendidoTarjeta:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.vendido === true
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.Devolucion:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.estado === ProcessoNums.Devolucion
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.MermaRoto:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.estado === ProcessoNums.MermaRoto
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.Envio:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.estado === ProcessoNums.Envio
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.PendientePago:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.estado === ProcessoNums.PendientePago
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.Reparacion:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.estado === ProcessoNums.Reparacion
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
      }
    }
  }
  add_to_cart(product: ProductoAmazon) {
    tienda_cart_module.addProductToCart(product);
  }

  // === Lógica del botón ===
  public toggleCart(product: ProductoAmazon): void {
    if (this.isInCart(product)) {
      this.removeFromCart(product);
    } else {
      this.add_to_cart(product);
    }
  }
  public removeFromCart(product: ProductoAmazon): void {
    tienda_cart_module.removeFromCart(product.id);
  }

  public isInCart(product: ProductoAmazon): boolean {
    var cart = tienda_cart_module.carritoCompra;
    for (var i = 0; i < cart.length; i++) {
      if ((cart[i] as any).id === product.id) return true;
    }
    return false;
  }

  @Watch("searchQueryExecute")
  onSearchQueryChange() {
    TiendaOnlineClientesModule.getTiendaOnlineClientesesTodosPaginacion({
      skip: 0,
      take: this.productsPerPage,
      selectedProcessoNumber: this.selectedProcessoNum || 0,
      search: this.searchQuery,
    });
  }
}
